var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasBanner)?_c('MapBanner',{attrs:{"text":_vm.characterText,"position":{ x: _vm.position.x - 64, y: _vm.position.y - 60 }},on:{"clicked":_vm.handleClick}}):_vm._e(),_c('div',{staticClass:"map-character",style:(_vm.characterStyle),on:{"click":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }